import React, { ChangeEvent, useEffect, useState } from 'react';
import Input from './form-control/Input';
import clsx from 'clsx';

export interface IVerifyInput {
  name?: string;
  id?: string;
  readOnly?: boolean;
  verified: boolean;
  label?: string;
  value?: string;
  onClick: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | null | any;
  error?: string | undefined;
  helperText?: string;
  required?: boolean;
  touched?:boolean;
  isVerifiedInput?: boolean;
  onBlur?: (e: React.FocusEvent<any>)=> void | null | any;
}
function VerifyInput({
  readOnly,
  verified,
  label,
  value,
  onClick,
  onChange,
  name,
  error,
  helperText,
  id,
  required = false,
  isVerifiedInput=true,
  onBlur
}: IVerifyInput) {
 // const [touched, setTouched] = useState<boolean>(false);

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center">
        <Input
          name={name}
          id={id}
          readOnly={readOnly}
          label={label}
          type="text"
          value={value}
          className={clsx(`${isVerifiedInput ? '!rounded-r-none' : ''}`, readOnly && '!bg-[#D1D5DB]')}
          onChange={onChange}
          required={required}
          onBlur={onBlur}
          error={ error}
          helperText={helperText}
        />

        {value &&
          <div className="">
            {verified ? (
              <div
                className={clsx(
                  'w-fitmd:w-[4rem]  px-2 text-green-500 rounded-r-full flex items-center justify-center h-[40px] border border-gray-400 font-bold cursor-default',
                  label && 'mt-6'
                )}>
                Verified
              </div>
            ) : (
              <div
                onClick={onClick}
                className={clsx(
                  'md:w-[4rem] font-bold text-xs text-red-500 rounded-r-full flex items-center justify-center h-[40px] border border-gray-400 px-1 cursor-pointer ',
                  label && 'mt-6'
                )}>
                Verify
              </div>
            )}
          </div>}

      </div>
    </div>
  );
}

export default VerifyInput;
